import { useNavigate, useSearchParams } from 'react-router-dom';
import { usePermissions } from '@practium/features/permissions';
import { SystemPage } from './SystemPage';
import type { SystemSubject, SystemTab } from '../types/system.types';

const TAB_SUBJECT: Record<SystemTab, SystemSubject> = {
	permissions: 'groups',
	hierarchies: 'hierarchies',
	plans: 'plans',
};

const isSystemTab = (value: string | null): value is SystemTab =>
	value === 'permissions' || value === 'hierarchies' || value === 'plans';

export const SystemPageAdmin = () => {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const tabParam = searchParams.get('tab');
	const initialTab: SystemTab = isSystemTab(tabParam) ? tabParam : 'permissions';
	const { abilities } = usePermissions();

	const handleAddNew = (tab: SystemTab) => {
		navigate(`/sistema/novo?type=${tab}`);
	};

	const handleViewItem = (tab: SystemTab, id: string) => {
		navigate(`/sistema/ver?type=${tab}&id=${id}`);
	};

	return (
		<SystemPage
			initialTab={initialTab}
			permissions={{
				canCreate: abilities.can('create', TAB_SUBJECT.permissions),
				canEdit: abilities.can('update', TAB_SUBJECT.permissions),
				canDelete: abilities.can('delete', TAB_SUBJECT.permissions),
			}}
			canCreateForTab={tab => abilities.can('create', TAB_SUBJECT[tab])}
			onAddNew={handleAddNew}
			onViewItem={handleViewItem}
		/>
	);
};
